<template>
	<v-container fluid>
		<v-row>
			<v-col
        cols="12"
        class="d-flex justify-end">
        <v-btn
          outlined
          color="primary"
          :style="btnAction.style"
					@click="getReports()">
          <v-icon left>
            mdi-reload
          </v-icon>

          Atualizar
        </v-btn>
      </v-col>

			<v-col cols="12">
				<v-data-table
					id="ReportTable"
					class="default-table-height"
					item-key="id"
					:headers="headers"
					:items="reports"
					:loading="loading"
					:items-per-page="itemsPerPage"
					:server-items-length="totalPages"
					:no-data-text="$t('reports.messages.noDataText')"
					:loading-text="$t('reports.messages.loadingText')"
					:no-result-text="$t('reports.messages.noResultText')"
					:page="page"
					:custon-sort="{
						isDescending: true
					}"
					:footer-props="{
						itemsPerPageOptions: [25, 50, 75, 100],
						disablePagination: loading
					}"
					@update:options="changePage($event)"
				>
					<template v-slot:no-data>
						<span>Nenhum dado encontrado.</span>
					</template>
					<template v-slot:[`item.reportLayout`]="{ }">
						{{ reportLayoutName }}
					</template>
					<template v-slot:[`item.reportName`]="{ item }">
						{{ item.reportName || "-" }}
					</template>
					<template v-slot:[`item.updatedAt`]="{ item }">
						<span style="white-space: nowrap">
							{{
								item.updatedAt
									? formatter.formatDateTimeZoneWithHours(item.updatedAt)
									: "-"
							}}
						</span>
					</template>
					<template v-slot:[`item.createdAt`]="{ item }">
						<span style="white-space: nowrap">
							{{
								item.createdAt
									? formatter.formatDateTimeZoneWithHours(item.createdAt)
									: "-"
							}}
						</span>
					</template>
					<template v-slot:[`item.financialGroupId`]="{ item }">
						{{ item.financialGroupId ? (getFinancialGroup(item.financialGroupId).name) : "-" }}
					</template>
					<template v-slot:[`item.requestUserName`]="{ item }">
						{{ item.requestUserName ? formatter.formatToTitleCase(item.requestUserName) : "-" }}
					</template>
					<template v-slot:[`item.status`]="{ item }">
						<span class="text--truncate">{{
							getReportsStatus(item.status)
						}}</span>
					</template>
					<template v-slot:[`item.errors`]="{ item }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<div v-bind="attrs" v-on="on">
									<v-btn
										color="error"
										icon
										@click="openMyReportsErrorModal(item.id)"
										:disabled="!item.hasError">
										<v-icon
											:color="item.hasError ? 'error' : ''"
											size="25">
											fas fa-times
										</v-icon>
									</v-btn>
								</div>
							</template>
							<span> Erro no relatório </span>
						</v-tooltip>
					</template>
					<template v-slot:[`item.actions`]="{ item }">
						<v-menu transition="slide-y-transition" offset-y>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									:disabled="item.status != 'SUCCESS'"
									icon
									v-bind="attrs"
									v-on="on"
									:loading="loadingReports[item.id]"
									@click="downloadReport(item.id, item.reportName)"
								>
									<v-icon
										color="primary">
										mdi-tray-arrow-down
									</v-icon>
								</v-btn>
							</template>
						</v-menu>
					</template>
				</v-data-table>
			</v-col>
		</v-row>

		<SnackbarCustomize ref="SnackbarCustomize" />

		<MyReportsErrorModal
			ref="MyReportsErrorModal"
			customDataTableId="ReportsErrorTable"
			:myReportsError="propsError"
			:loadingTableMyReportsError="loadingErrorsModal"
			@cleanErrors="propsError = []"
		/>
	</v-container>
</template>

<script>
import MyReportsErrorModal from '@/components/DashboardMovementRecords/MyReports/MyReportsErrorModal.vue';
import AuthorityManagementMixin from "@/shared/mixins/authorityManagement/authorityManagementMixin";
import ReportAutomationMixin from '@/shared/mixins/reportAutomation/reportAutomationMixin';
import MovementRecordsMixin from "@/shared/mixins/movementRecords/movementRecordsMixin";
import SnackbarCustomize from "@/components/CustomAlerts/SnackbarCustomize.vue";
import MyReportsService from "@/services-http/sdi/MyReportsService.js";
import MyReportsMixin from "@/shared/mixins/myReports/myReportsMixin";
import FileDataService from '@/services-http/sdi/FileDataService';
import ReportMixin from '@/shared/mixins/report/reportMixin';
import Formatters from "@/shared/formatters/formatters";
import { cloneDeep } from "lodash";
import { mapGetters } from 'vuex';

export default {
	name: "ReportTable",
	components: {
		SnackbarCustomize,
		MyReportsErrorModal
	},
	data: () => ({
		loadingReports: {},
		loading: false,
		hasAuthorityUploadMyReports: false,
		loadingErrorsModal: false,
		reportServices: null,
		fileDataService: null,
		page: 1,
		itemsPerPage: 25,
		totalPages: 0,
		propsError: [],
		reports: [],
    	isRHProtegido: false,
		headers: [
			{
				text: "Layout de Relatório",
				value: "reportLayout",
				align: "start",
				cellClass: "report-layout",
				class: "report-layout",
				sortable: false
			},
			{
				text: "Nome do arquivo",
				value: "reportName",
				align: "start",
				cellClass: "report-filename",
				class: "report-filename",
				sortable: false
			},
			{
				text: "Grupo Financeiro",
				value: "financialGroupId",
				align: "start",
				cellClass: "report-financial-group",
				class: "report-financial-group",
				sortable: false
			},
			{
				text: "Solicitado por",
				value: "requestUserName",
				align: "start",
				cellClass: "report-request-username",
				class: "report-request-username",
				sortable: false
			},
			{
				text: "Data da Solicitação",
				value: "createdAt",
				align: "start",
				cellClass: "report-created-at",
				class: "report-created-at",
				sortable: false
			},
			{
				text: "Data da Emissão",
				value: "updatedAt",
				align: "start",
				cellClass: "report-updated-at",
				class: "report-updated-at",
				sortable: false
			},
			{
				text: "Status",
				value: "status",
				align: "start",
				class: "report-status",
				cellClass: "report-status",
				sortable: false
			},
			{
				text: "Erro",
				value: "errors",
				align: "start",
				class: "report-error",
				cellClass: "report-error",
				sortable: false
			},
			{
				text: "Ações",
				value: "actions",
				align: "start",
				cellClass: "report-actions",
				class: "report-actions",
				sortable: false
			}
		]
	}),
	mixins: [
		AuthorityManagementMixin,
		ReportAutomationMixin,
		MovementRecordsMixin,
		MyReportsMixin,
		ReportMixin,
	],
	props: {
		filter: {
			type: Object,
		},
		reportDefaultType: {
			type: String,
			default: 'REPORT_INSURED'
		},
		reportLayoutName: {
			type: String,
			default: 'Arquivo de Beneficiário',
		}
	},
	watch: {
		filter: {
			handler(newFilter) {
				this.filterMyReports = newFilter;
			}
		}
	},
	created() {
		this.formatter = new Formatters()
	},
	async mounted() {
		this.hasAuthorityUploadMyReports = true
		this.fileDataService = new FileDataService();
		this.reportServices = new MyReportsService();
    this.isRHProtegido = this.$route.query.isRHProtegido
	},
	methods: {
		// Update filters and restart report search
		async handlerFilter(value, type) {
			this.page = 1
			this.filterMyReports = cloneDeep(value)
			await this.getReports()
		},
		// Change table page
		async changePage(event) {
			this.itemsPerPage = event.itemsPerPage;
      if (this.page !== event.page) {
        this.handlePageChange(event);
      }
    },
		// Set the paging data
		async handlePageChange(event) {
      const { page: newPage, itemsPerPage } = event;
      this.page = newPage;
      this.itemsPerPage = itemsPerPage;
      await this.getReports();
    },
		// Download the selected report
		async downloadReport(id, filename) {
			this.$set(this.loadingReports, id, true);
			await this.fileDataService.DownloadReport(id).then((response) => {
        if (response) {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${filename}`);
          document.body.appendChild(fileLink);
          fileLink.click();
					this.$set(this.loadingReports, id, false);
          this.$refs.SnackbarCustomize.open('success', 'Download realizado com sucesso.', 3000);
        }
      }).catch(() => {
				this.$set(this.loadingReports, id, false);
        this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao tentar efetuar o download.');
      });
		},
		// Search reports with current filters
		async getReports() {
			this.loading = true
			try {
				const filteredParams = this.getFilteredParams();
				if ('status' in filteredParams && filteredParams.status.length > 0 && filteredParams.status.includes("PARTIAL_FINISH")) {
					filteredParams.isPartialFinished = true;
				}
				const params = this.buildSearchParams(filteredParams, "search");
				await this.reportServices.GetReports(params)
					.then((response) => {
						if (response.data) {
							this.reports = response.data.content;
							this.totalPages = response.data.totalElements;
						}
					})
			} catch (error) {
				this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao buscar os relatórios.');
			}
			this.loading = false
		},
		// Assembles and returns the parameters of the this.filterMyReports object
		getFilteredParams() {
			return Object.entries(this.filterMyReports)
				.filter(([key, value]) => value && value !== "")
				.reduce((element, [key, value]) => ({ ...element, [key]: value }), {})
		},
		// Assembles and returns the parameters that will be sent in the request
		buildSearchParams(filteredParams, type) {
			const formattedFilterParams = cloneDeep(filteredParams)
			this.deleteEmptyParams(formattedFilterParams)
			return new URLSearchParams({
				...formattedFilterParams,
				reportLayout: this.reportDefaultType,
				isRHProtegido: this.isRHProtegido,
				page: this.page - 1,
				size: this.itemsPerPage,
				sort: "id,desc"
			})
		},
		// Remove parameters with value equal to '', null or undefined
		deleteEmptyParams(params) {
			Object.keys(params).forEach((key) => {
				if (["", null, undefined].some(item => item === params[key])) delete params[key]
			})
		},
		// Presents screen errors through the dialog component
		async openMyReportsErrorModal(reportId) {
			await this.reportServices.GetReportError(reportId).then((res) => {
				if (res && res.data && res.data.length > 0) {
					this.propsError = res.data;
				}
			}).catch(() => {
				this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao buscar os relatórios.');
			});
      this.$refs.MyReportsErrorModal.openModal();
		},
		// searches the financial group presented in the data-table
		getFinancialGroup(financialGroupId) {
			return this.financialGroups.find(el => el.id === financialGroupId) || '-'
		}
	},
	computed: {
		...mapGetters({
			financialGroups: 'financial-group/groups',
		}),
	}
}
</script>

<style lang="scss">
.theme--dark #ReportTable {
  border-radius: 5px !important;
  box-shadow: 0px 2px 6px color-mix(in srgb, var(--v-shadow-base) 26%, transparent) !important;
  > .v-data-table__wrapper {
    border-radius: 5px 5px 0px 0px !important;
    > table {
      > .v-data-table-header {
        border-radius: 5px 5px 0px 0px !important;
        background-color: var(--v-muted-foreground-base) !important;
        > tr {
          height: 70px;
          max-height: 70px;
          border-radius: 5px !important;
          > th > span {
            color: var(--v-primary-base) !important;
          }
        }
      }
      > tbody > tr {
        height: 70px;
        max-height: 70px;
      }
    }
  }
}

.theme--light #ReportTable {
  border-radius: 5px !important;
  box-shadow: 0px 2px 6px color-mix(in srgb, var(--v-shadow-base) 26%, transparent) !important;
  > .v-data-table__wrapper {
    border-radius: 5px 5px 0px 0px !important;
    > table {
      > .v-data-table-header {
        border-radius: 5px 5px 0px 0px !important;
        background-color: var(--v-primary-base) !important;
        > tr {
          height: 70px;
          max-height: 70px;
          border-radius: 5px !important;
          > th > span {
            color: var(--v-muted-base) !important;
          }
        }
      }
      > tbody > tr {
        height: 70px;
        max-height: 70px;
      }
    }
  }
}

.report-layout { width: 95px; }
.report-filename { width: 95px; }
.report-financial-group { width: 95px; }
.report-request-username { width: 95px; }
.report-created-at { width: 95px; }
.report-updated-at { width: 95px; }
.report-status { width: 95px; }
.report-error { width: 95px; }
.report-actions { width: 95px; }
</style>